import { Typography, TypographyProps } from '@mui/material';
import { YoutubeBroadcastCardSize } from './youtube-broadcast-card-size';

interface YoutubeBroadcastCardTitleProps {
  title: string;
  size: YoutubeBroadcastCardSize;
}

const titleVariantBySize: Record<YoutubeBroadcastCardSize, TypographyProps['variant']> = {
  small: 'body2',
  // subtitle2 uses fontWeight 500 and reads as bold; subtitle1 matches FragmentCardTitle.
  medium: 'subtitle1',
  large: 'subtitle1',
};

const TITLE_LINE_HEIGHT = 1.2;
const TITLE_LINE_CLAMP = 2;

/** Clamped broadcast title for grid cards; density varies by card size. */
export function YoutubeBroadcastCardTitle({ title, size }: YoutubeBroadcastCardTitleProps) {
  const variant = titleVariantBySize[size];

  return (
    <Typography
      variant={variant}
      component="h3"
      title={title}
      sx={{
        lineHeight: TITLE_LINE_HEIGHT,
        // Reserve two lines even for short titles, matching FragmentCardTitle layout.
        height: `${TITLE_LINE_HEIGHT * TITLE_LINE_CLAMP}em`,
        display: '-webkit-box',
        WebkitLineClamp: TITLE_LINE_CLAMP,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {title}
    </Typography>
  );
}
